import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TelegramWebApiService from '../services/TelegramWebApiService';

function useBackButton(showButton = false) {
	const navigate = useNavigate();
	useEffect(() => {
		TelegramWebApiService.Ready();
		if (showButton) {
			TelegramWebApiService.TelegramWebApi.BackButton.show();
			const onClickBackButton = () => navigate(-1);
			TelegramWebApiService?.TelegramWebApi?.onEvent('backButtonClicked', onClickBackButton);
			return () => {
				TelegramWebApiService?.TelegramWebApi?.offEvent('backButtonClicked', onClickBackButton);
			};
		} else {
			TelegramWebApiService.TelegramWebApi.BackButton.hide();
		}
	}, [showButton, navigate]);
}

export default useBackButton;
